import React from 'react';
import PropTypes from 'prop-types';
import { BASE_URL } from '../constants';

const SvgImage = props => {
  const {
    category,
    className,
    height,
    id,
    image,
    artistFull,
    onClick,
    onMouseEnter,
    onMouseLeave,
    posX,
    posY,
    visible,
    width,
  } = props;
  const display = visible ? null : { display: 'none' };
  return (
    <image
      alt={artistFull}
      className={className}
      data-artist={artistFull}
      data-category={category}
      height={height}
      id={id}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={display}
      width={width}
      xlinkHref={`${BASE_URL}${image}`}
      x={posX}
      y={posY}
    />
  );
};

SvgImage.defaultProps = {
  artistFull: '',
  category: '',
  className: '',
  height: null,
  id: null,
  image: null,
  onClick: null,
  onMouseEnter: null,
  onMouseLeave: null,
  posX: null,
  posY: null,
  visible: true,
  width: null,
};

SvgImage.propTypes = {
  artistFull: PropTypes.string,
  category: PropTypes.string,
  className: PropTypes.string,
  height: PropTypes.number,
  id: PropTypes.number,
  image: PropTypes.string,
  onClick: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  posX: PropTypes.number,
  posY: PropTypes.number,
  visible: PropTypes.bool,
  width: PropTypes.number,
};
export default SvgImage;
